import Rails from '@rails/ujs';

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['filterGroup', 'filterResult', 'row'];

  filter (){
    let rowStyle = 'table-row';

    const group = this.filterGroupTarget.value;
    const result = this.filterResultTarget.value;

    this.rowTargets.forEach((row) => {
      let visible = true;

      if ('' === group || row.querySelector('.group').textContent === group) {
        visible = visible && true;
      } else {
        visible = visible && false;
      }

      if ('' === result) {
        visible = visible && true;
      } else {
        if ('Артикулы находятся в разных кроссах' === result) {
          if (row.textContent.includes('Артикулы находятся в разных кроссах')) {
            visible = visible && true;
          } else {
            visible = visible && false;
          }
        }

        if ('Деталь не добавлена ни в одну категорию' === result) {
          if (row.textContent.includes('Деталь не добавлена ни в одну категорию')) {
            visible = visible && true;
          } else {
            visible = visible && false;
          }
        }

        if ('Категория детали не связана с моделю текущего грузовика' === result) {
          const allCheckboxes = row.querySelectorAll('.is-visible input[type="checkbox"]').length;
          const checkedCheckboxes = row.querySelectorAll('.is-visible input[type="checkbox"]:checked').length;
          if (allCheckboxes !== checkedCheckboxes) {
            visible = visible && true;
          } else {
            visible = visible && false;
          }
        }
      }

      if (visible) {
        row.style.display = 'table-row';
      } else {
        row.style.display = 'none';
      }
    });
  }

  filterByResult() {
  }

  submitClosestForm(event) {
    Rails.fire(event.target.closest('form'), 'submit');
  }
}
